<template>
    <div class="main">
        <v-row justify="center">
            
            <v-dialog persistent v-model="dialogEditGrandFatherName" max-width="500">
                <v-form ref="formChangeEditGrandFatherName" class="slim">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Cambiar nombre del Tipo de Elemento</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-row align="center" class="mx-0 mt-4">
                            </v-row>
                            <div class="my-4 subtitle-1 black--text">
                                <strong>Editar nombre</strong>
                                <v-row style="margin-top: 5px;">
                                    <v-col sm="12" md="12">
                                        <v-text-field class="pr-3 mx-280" v-model="grandFatherNameNew" label="Nombre Tipo de Elemento" clearable outlined dense :rules="grandFatherNameNewRule" @keyup.enter="changeGrandFatherName()"></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-card-text>

                        <v-card-actions class="px-6 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn text small @click="dialogEditGrandFatherName=false;">
                                Cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="changeGrandFatherName()">
                                Cambiar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog persistent v-model="dialogConfirmCleanChildOfGrandFather" max-width="500">
                <v-card class="mx-auto">
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Confirmación</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-row align="center" class="mx-0 mt-4">
                        </v-row>
                        <div class="my-4 subtitle-1 black--text">
                            Si ANULA la selección este nodo, se limpiarán todos los nodos hijos a apartir de este nivel de la lista del lado derecho. <br /> ¿Desea Continuar?
                        </div>

                    </v-card-text>

                    <v-card-actions class="px-6 pb-6">
                        <v-spacer></v-spacer>
                        <v-btn text small @click="itemSelected.selected=true;dialogConfirmCleanChildOfGrandFather=false;">
                            NO
                        </v-btn>
                        <v-btn color="blue" dark small @click="cleanChildOfGrandFather()">
                            SI
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog persistent v-model="dialogConfirmSaveVariables" max-width="500">
                <v-card class="mx-auto">
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Confirmación</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-row align="center" class="mx-0 mt-4">
                        </v-row>
                        <div class="my-4 subtitle-1 black--text">
                            A continuación se guardarán las variables seleccionadas. <br /> ¿Desea Continuar?
                        </div>

                    </v-card-text>

                    <v-card-actions class="px-6 pb-6">
                        <v-spacer></v-spacer>
                        <v-btn text small @click="dialogConfirmSaveVariables=false;">
                            NO
                        </v-btn>
                        <v-btn color="blue" dark small @click="saveDataVariables()">
                            SI
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog persistent v-model="dialogChangeSupervisor" max-width="500">
                <v-card class="mx-auto">
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Confirmación</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-row align="center" class="mx-0 mt-4">
                        </v-row>
                        <div class="my-4 subtitle-1 black--text">
                            Existe variables agregadas y editadas, si continua se borrarán dichas variables. ¿Desea Continuar?
                        </div>

                    </v-card-text>

                    <v-card-actions class="px-6 pb-6">
                        <v-spacer></v-spacer>
                        <v-btn text small @click="closeDialogChangeSupervisor()">
                            NO
                        </v-btn>
                        <v-btn color="blue" dark small @click="bindTiposAndVariables()">
                            SI
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog persistent v-model="dialogAddVariable" max-width="500">
                <v-form ref="formAddVariable" class="slim">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>{{itemVariable ? itemVariable.name : ''}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pb-0">
                            <v-row align="center" class="mx-0 mt-4">
                            </v-row>
                            <div class="my-4 subtitle-1 black--text">
                                <strong>Editar nombre de la variable</strong>
                                <v-row style="margin-top: 5px;">
                                    <v-col sm="12" md="12">
                                        <v-text-field class="pr-3 mx-280" v-model="itemVariable.nameNew" label="Nombre Variable" clearable outlined dense :rules="reglaNameNew" @keyup.enter="addVariable()"></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-card-text>

                        <v-card-actions class="px-6 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn text small @click="closeDialogAddVariable(itemVariable)">
                                Cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="addVariable()">
                                Aceptar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-card max-width="95%" class="mx-auto" style="margin-top: 30px;">
                <!--------------------------------------NewForm---------------------------------------------->
                <template v-if="nuevoForm">
                    <v-row justify="center">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Agregar Instalación</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <v-tabs v-model="tab" grow background-color="#90CAF9">
                            <v-tabs-slider color="blue"></v-tabs-slider>
                            <v-tab href="#instalacion">Instalación</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item :key="1" value="instalacion">
                                <v-card class="mx-auto">
                                    <v-form ref="formularioNuevo" class="slim">
                                        <v-container class="d-flex pt-6 flex-row flex-wrap">
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCodigo" label="Código" outlined dense :rules="reglaCodigoInstalacion"></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTNombre" label="Nombre" outlined dense :rules="reglaNombreInstalacion"></v-text-field>

                                            <v-autocomplete class="pr-2 mx-240 " v-model="instalation.fkNEmpresa" :items="companies" item-text="fldTNombre" item-value="idNEmpresa" label="Empresa" clearable outlined dense :rules="reglaEmpresa"></v-autocomplete>

                                            <!--Tipo Relacion Empresa Instalacion-->
                                            <v-autocomplete class="pr-2 mx-240" v-model="instalation.fkNTipoRelacionEmpresaInstalacion" :items="tiposRelacionesInstalacionEmpresa" item-text="fldTNombre" item-value="idNTipoRelacionEmpresaInstalacion" :rules="reglaTipoRelacionInstalacionEmpresa" label="Tipo Relación con Empresa" clearable outlined dense></v-autocomplete>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNMunicipio" :items="municipalities" item-text="fldTMunicipioEndonimo" item-value="idMunicipio" label="Municipio" clearable outlined dense></v-autocomplete>

                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTDireccion" label="Dirección" outlined dense></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCP" label="Código Postal" outlined dense></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTTelefono" label="Telefono" outlined dense></v-text-field>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNGestor" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Gestor de mantenimiento" outlined clearable dense></v-autocomplete>
                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNJefeZona" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Jefe de zona" outlined clearable dense></v-autocomplete>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNTecnico" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Técnico" outlined clearable dense></v-autocomplete>
                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNEjecutivo" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Ejecutivo" outlined clearable dense></v-autocomplete>

                                            <v-menu v-model="menuFechaApertura" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDApertura" label="Fecha de apertura" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDApertura" locale="es-es" @input="menuFechaApertura = false"></v-date-picker>
                                            </v-menu>

                                            <v-menu v-model="menuFechaCierre" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDCierre" label="Fecha de cierre" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDCierre" locale="es-es" @input="menuFechaCierre = false"></v-date-picker>
                                            </v-menu>

                                            <v-menu v-model="menuFechaAlta" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDAlta" label="Fecha de alta" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDAlta" locale="es-es" @input="menuFechaAlta = false"></v-date-picker>
                                            </v-menu>
                                            <v-menu v-model="menuFechaBaja" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDBaja" label="Fecha de baja" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDBaja" locale="es-es" @input="menuFechaBaja = false"></v-date-picker>
                                            </v-menu>
                                            <v-autocomplete class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" :items="iconList" item-text="fldTNombre" item-value="idNIcono" label="Icono" clearable outlined dense></v-autocomplete>
                                            <!--<image-selector class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" dense></image-selector>-->
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLongitud" label="Longitud" outlined dense @change="saveMarker"></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLatitud" label="Latitud" outlined dense @change="saveMarker"></v-text-field>
                                            <v-card-actions class="btns-float px-6 pb-6">
                                                <!--<v-btn text small @click="nuevoForm = false">
                                            cancelar
                                        </v-btn>-->
                                                <v-btn color="blue" dark small @click="saveData">
                                                    Guardar cambios
                                                </v-btn>
                                            </v-card-actions>

                                        </v-container>
                                    </v-form>

                                </v-card>
                            </v-tab-item>


                        </v-tabs-items>


                    </v-row>
                </template>

                <!--------------------------------------EditForm---------------------------------------------->
                <template v-if="!nuevoForm">
                    <v-row justify="start">

                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Editar Instalación</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <v-tabs v-model="tab" grow background-color="#90CAF9">
                            <v-tabs-slider color="blue"></v-tabs-slider>
                            <v-tab href="#instalacion">Instalación</v-tab>
                            <v-tab href="#supervisor">Supervisores</v-tab>
                            <v-tab href="#tipos">Tipos de elementos y variables</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item :key="1" value="instalacion">
                                <v-card class="mx-auto">
                                    <v-form ref="formularioEdicion" class="slim">
                                        <v-container class="d-flex pt-6 flex-row flex-wrap justify-center">
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCodigo" label="Código de instalación" outlined dense :rules="reglaCodigoInstalacion" :disabled="puedeCambiar == false"></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTNombre" label="Nombre de la instalación" outlined dense :rules="reglaNombreInstalacion" :disabled="puedeCambiar == false"></v-text-field>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNEmpresa" :items="companies" item-text="fldTNombre" item-value="idNEmpresa" label="Empresa" clearable outlined dense :rules="reglaEmpresa" :disabled="puedeCambiar == false" @change="actualizarRelacionEmpresaInstalacion"></v-autocomplete>
                                            <!--Tipo Relacion Empresa Instalacion-->
                                            <v-autocomplete class="pr-2 mx-240" v-model="instalation.fkNTipoRelacionEmpresaInstalacion" :items="tiposRelacionesInstalacionEmpresa" item-text="fldTNombre" item-value="idNTipoRelacionEmpresaInstalacion" label="Tipo Relación con Empresa" :rules="reglaTipoRelacionInstalacionEmpresa" :disabled="puedeCambiar == false" clearable outlined dense></v-autocomplete>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNMunicipio" :items="municipalities" item-text="fldTMunicipioEndonimo" item-value="idMunicipio" label="Municipio" clearable outlined dense :disabled="puedeCambiar == false"></v-autocomplete>

                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTDireccion" label="Dirección" outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCP" label="Código Postal" outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldTTelefono" label="Telefono" outlined dense :disabled="puedeCambiar == false"></v-text-field>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNGestor" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Gestor de mantenimiento" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>
                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNJefeZona" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Jefe de zona" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>

                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNTecnico" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Técnico" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>
                                            <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNEjecutivo" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Ejecutivo" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>

                                            <v-menu v-model="menuFechaAperturaEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDApertura" label="Fecha de apertura" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDApertura" locale="es-es" @input="menuFechaAperturaEdit = false"></v-date-picker>
                                            </v-menu>

                                            <v-menu v-model="menuFechaCierreEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDCierre" label="Fecha de cierre" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDCierre" locale="es-es" @input="menuFechaCierreEdit = false"></v-date-picker>
                                            </v-menu>

                                            <v-menu v-model="menuFechaAltaEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDAlta" label="Fecha de alta" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDAlta" locale="es-es" @input="menuFechaAltaEdit = false"></v-date-picker>
                                            </v-menu>
                                            <v-menu v-model="menuFechaBajaEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field class="pr-3 mx-240" v-model="instalation.fldDBaja" label="Fecha de baja" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="instalation.fldDBaja" locale="es-es" @input="menuFechaBajaEdit = false"></v-date-picker>
                                            </v-menu>
                                            <v-autocomplete class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" :items="iconList" item-text="fldTNombre" item-value="idNIcono" label="Icono" :disabled="puedeCambiar == false" clearable outlined dense></v-autocomplete>
                                            <!--<image-selector class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" dense :disabled="puedeCambiar == false" outlined label="Icono"></image-selector>-->
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLongitud" label="Longitud" outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLatitud" label="Latitud" outlined dense :disabled="puedeCambiar == false"></v-text-field>

                                            <v-card-actions class="justify-space-between w-100 pb-6">
                                                <div class="justify-right">
                                                    <v-btn v-if="puedeCambiar" class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                                        Cancelar
                                                    </v-btn>
                                                    <template v-if="activateEdit">
                                                        <v-btn v-if="!puedeCambiar" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                                            <v-icon left>mdi-pencil</v-icon> Editar
                                                        </v-btn>
                                                        <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                                            <v-icon left>mdi-pencil</v-icon> Guardar
                                                        </v-btn>
                                                    </template>
                                                </div>
                                            </v-card-actions>
                                        </v-container>
                                    </v-form>
                                </v-card>
                                <br />
                                <v-card class="mx-auto" style="height:70vh;" outlined v-if="instalation.fldNLongitud && instalation.fldNLatitud">
                                    <GmapMap style="width: 100%; height: 100%;" :zoom="zoom" :center="center" ref="map" :options="mapOptions">
                                        <GmapMarker :key="index"
                                                    v-for="(m, index) in markers"
                                                    :position="m.position"
                                                    @click="center=m.position" />
                                    </GmapMap>
                                </v-card>
                                <v-card style="height:10vh;" v-if="instalation.fldNLongitud===null || instalation.fldNLatitud===null">
                                    <h4>Deberá ingresar latitud y longitud en los datos de la instalación</h4>
                                </v-card>
                            </v-tab-item>

                            <v-tab-item :key="2" value="supervisor">

                                <v-card fluid width="100vw">
                                    <v-container class="d-flex pt-6 flex-row flex-wrap justify-center" v-if="supervisor.idNSupervisor===null && !nuevoFormSupervisor">
                                        <v-btn color="accent" small dark @click="addSupervisor">Agregar Supervisor</v-btn>
                                    </v-container>
                                    <v-container v-if="nuevoFormSupervisor">
                                        <v-toolbar color="blue" dark>
                                            <v-toolbar-title>{{supervisor.idNSupervisor ? 'Editar' : 'Nuevo'}} Supervisor</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                        <v-form ref="formularioNuevoSupervisor" class="slim">
                                            <v-container class="d-flex pt-6 flex-row flex-wrap">
                                                <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTNombre" label="Nombre" :rules="nombreRules" outlined dense></v-text-field>
                                                <v-autocomplete class="pr-3 mx-240" v-model="supervisor.fkNVersion" :items="versions" item-text="fldTNombre" item-value="idNVersionSupervisor" label="Version" outlined :rules="versionRules" clearable dense></v-autocomplete>
                                                <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTVariableReceptoraNX" label="Variable Receptora NX" :rules="variableReceptoraRules" outlined dense></v-text-field>
                                                <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTIp" label="IP" outlined dense></v-text-field>
                                                <!--<v-text-field class="mx-240" v-model="supervisor.fldDUltimaTransmisionRecibida" label="Ultima Transmision Recibida" :rules="ultimaTransmisionRules" outlined dense></v-text-field>-->
                                                <v-card-actions class="btns-float px-6 pb-6">
                                                    <v-btn text small @click="nuevoFormSupervisor = false; supervisor.idNSupervisor=null">
                                                        cancelar
                                                    </v-btn>
                                                    <v-btn color="blue" dark small @click="saveDataSupervisor">
                                                        Guardar cambios
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-container>
                                        </v-form>
                                    </v-container>
                                    <v-container v-if="!nuevoFormSupervisor">
                                        <v-data-table dense :headers="headers_supervisores" :items="supervisors" :items-per-page="5" :footer-props="{'items-per-page-options': [5, 10, 20, 50]}" class="py-0 px-0">
                                            <template v-slot:item.ico1="{ item }">
                                                <v-chip :color="item.ico1" dark label></v-chip>
                                            </template>
                                            <template v-slot:item.fkNInstalacion="{ item }">
                                                {{getInstaDescription(item.fkNInstalacion)}}
                                            </template>
                                            <template v-slot:item.fkNVersion="{ item }">
                                                {{getVerDescription(item.fkNVersion)}}
                                            </template>
                                            <template v-slot:item.fldDUltimaTransmisionRecibida="{item}">
                                                {{getUltimaTransmisionRecibida(item.fldDUltimaTransmisionRecibida)}}
                                            </template>

                                            <template v-slot:item.action="{ item }">
                                                <v-icon color="green" @click="editItemSupervisor(item)" class="ml-3">
                                                    mdi-pencil
                                                </v-icon>
                                            </template>


                                        </v-data-table>
                                    </v-container>
                                </v-card>

                            </v-tab-item>
                            <v-tab-item :key="3" value="tipos">
                                <v-card fluid width="100vw">
                                    <v-container class="d-flex pt-3 flex-wrap justify-center">
                                        <v-autocomplete v-model="idNSupervisor"
                                                        :items="supervisors" item-text="fldTNombre"
                                                        item-value="idNSupervisor" label="Supervisor"
                                                        outlined clearable dense @change="openDialogChangeSupervisor()"></v-autocomplete> <!--loadTiposElementos();loadVariables();-->
                                        <v-tabs v-model="tabsec" grow background-color="#c8f2ce">
                                            <v-tabs-slider color="#009816"></v-tabs-slider>
                                            <v-tab href="#variables">Elementos</v-tab>
                                            <v-tab href="#elementos">Añadir nuevos Elementos</v-tab>

                                        </v-tabs>
                                        <v-tabs-items v-model="tabsec">
                                            <!--:key="elementos"-->
                                            <v-tab-item value="variables">
                                                <TabIzqElementos ref="tabIzquierdo" v-on:messageFromChild="childMessageReceived" :idNSupervisor="this.$data.idNSupervisor" :selectionVariables="this.$data.selectionVariables">
                                                </TabIzqElementos>
                                            </v-tab-item>
                                            <!--:key="Añadir Nuevos Elementos"-->
                                            <v-tab-item value="elementos">
                                                <v-card fluid width="100vw">
                                                    <v-container class="d-flex pt-2 flex-wrap justify-center">
                                                        <template v-if="!tiposElementosItems.length" style="font-weight: 300;">
                                                            <br />
                                                            Seleccione primero el Supervisor para ver los Elementos disponibles.
                                                        </template>
                                                        <template v-else>
                                                            <v-row style="padding: 0;" justify="center">
                                                                <v-col class="pa-0" cols="12" align="right" v-if="listItemSelected.length>0" style="margin-top: 15px">
                                                                    <v-btn large dark small color="blue" @click="dialogConfirmSaveVariables=true;">
                                                                        Guardar cambios
                                                                    </v-btn>
                                                                </v-col>
                                                                <v-col cols="5" class="pl-0">
                                                                    <v-card-title class="justify-center" style=" background-color: lightgray !important; padding: 4px;">
                                                                        Elementos Disponibles
                                                                    </v-card-title>
                                                                    <v-treeview :active.sync="active"
                                                                                :items="tiposElementosItems"
                                                                                :load-children="fetchLevel"
                                                                                :open.sync="open"
                                                                                activatable
                                                                                active-class="primary--text"
                                                                                class="grey lighten-5 item-font"
                                                                                open-on-click
                                                                                transition
                                                                                dense
                                                                                style="padding-top: 10px">
                                                                        <template v-slot:prepend="{ item, active }">
                                                                            <v-icon v-if="item.level!==4 && !item.children"
                                                                                    :color="active ? 'primary' : ''">
                                                                                mdi-account
                                                                            </v-icon>
                                                                            <div v-if="item.level===2">
                                                                                <input type="checkbox" v-model="item.selected" class="checkMargin" @click="openDialogAddVariableByLote(item)" :disabled="item.allVarsSelected">
                                                                            </div>
                                                                            <div v-if="item.level===4">
                                                                                <input type="checkbox" v-model="item.selected" class="checkMargin" @click="openDialogAddVariable(item, 'add')" :disabled="item.selected">
                                                                            </div>
                                                                        </template>

                                                                    </v-treeview>
                                                                </v-col>
                                                                <v-col cols="7" class="pr-0">
                                                                    <v-card-title class="justify-center" style=" background-color: lightgray !important; padding: 4px;">
                                                                        Elementos y/o Variables seleccionadas
                                                                    </v-card-title>
                                                                    <template v-if="listItemSelected.length===0" class="item-font" style="font-weight: 200; font-size: 7px;">
                                                                        <p style="margin-left: 20px;">
                                                                            <br />
                                                                            No hay elementos en esta lista.
                                                                            <br /> Seleccione los elementos que desea agregar en la lista del lado izquierdo.
                                                                        </p>
                                                                    </template>
                                                                    <v-list>

                                                                        <v-list-group v-for="item in listItemSelected" :key="item.name" v-model="item.active" no-action sub-group>

                                                                            <template v-slot:activator>

                                                                                <v-list-item-content>
                                                                                    <v-list-item-title v-text="item.name">

                                                                                    </v-list-item-title>

                                                                                </v-list-item-content>
                                                                                <span style="font-size: 12px">{{ item.path }}</span>
                                                                                <v-list-item-icon>
                                                                                    <v-icon class="menu-icon small" color="green" @click="openEditGrandFatherName(item)">
                                                                                        mdi-file-document-edit
                                                                                    </v-icon>
                                                                                </v-list-item-icon>

                                                                            </template>

                                                                            <v-list-item-group class="pl-10">

                                                                                <v-list-item v-for="child in item.variables" :key="child.id" sub-group>

                                                                                    <v-list-item-content style="padding-top: 4px">

                                                                                        <v-list-item-title style="font-size: 14px">
                                                                                            <v-icon class="menu-icon small" color="red" @click="removeItem(child)">
                                                                                                mdi-trash-can
                                                                                            </v-icon>
                                                                                            <v-icon class="menu-icon small" color="green" @click="openDialogAddVariable(child,'edit')">
                                                                                                mdi-file-document-edit
                                                                                            </v-icon> {{ child.name}} <span style="font-size: 12px; float: right">{{ child.path }}</span>
                                                                                        </v-list-item-title>

                                                                                    </v-list-item-content>

                                                                                </v-list-item>

                                                                            </v-list-item-group>

                                                                        </v-list-group>
                                                                    </v-list>
                                                                </v-col>
                                                            </v-row>

                                                        </template>
                                                    </v-container>
                                                </v-card>
                                            </v-tab-item>

                                        </v-tabs-items>

                                    </v-container>


                                </v-card>

                            </v-tab-item>
                        </v-tabs-items>

                    </v-row>
                </template>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import {
        Component,
        Prop,
        Vue
    } from "vue-property-decorator";
  
    import InstalationCompanyRelationshipService from "../services/InstalationCompanyRelationshipService";
    import InstalationService from '@/services/InstalationsService';
    import MunicipalityService from '@/services/MunicipalityService';
    import ContactService from '@/services/ContactService';
    import CompanyService from '@/services/CompanyService';
    import IconService from '@/services/IconService';
    import InstalationCompanyRelationshipClassService from "../services/InstalationCompanyRelationshipClassService";
    import InstalationModel from '@/models/InstalationModel';
    import InstalationCompanyRelationshipModel from '@/models/InstalationCompanyRelationshipModel';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import Confirm from '@/components/ConfirmDelete';
    import TabIzqElementos from '@/components/TabIzqElementos';
    import ImageSelector from '@/components/ImageSelector';   
    import moment from "moment";
    import SupervisorService from "../services/SupervisorService";
    import SupervisorModel from "../models/SupervisorModel";
    import VersionService from "../services/VersionService";
    import GmapCluster from 'vue2-google-maps/src/components/cluster'
    import ElementTypeService from "../services/ElementTypeService";
    import VariableService from "../services/VariableService";


    @Component({
        components: {
            Confirm,
            TabIzqElementos,
            ImageSelector,
            GmapCluster
        }
    })
    export default class InstalacionesWizard extends Vue {
        childMessageReceived() {
            this.$data.listItemSelected = [];
            this.$data.idNSupervisor = null;
            this.$data.tiposElementosItems = [];
            this.$data.selectionVariables = [];
        }
        //treeview
        async fetchLevel(item) {
            if (item.level === 3) {

                //TODO Asignar un children "Loading..."

                var data = await new ElementTypeService()
                                        .listTiposVariables({
                                            idNAgrupacionVariable: item.id,
                                            idNTipoElemento: item.parentId,
                                            idNAgrupacionElemento: item.grandParentId,
                                            idNVersionSupervisor: item.grandGrandParentId,
                                            idNSupervisor: this.$data.idNSupervisor
                                        });              
                item.children = data.data;

                //console.log(JSON.stringify(data.data));

                /*var data1 = await new ElementTypeService()
                    .listTiposVariablesByTipoElemento({
                        idNTipoElemento: item.parentId,
                        idNAgrupacionElemento: item.grandParentId,
                        idNVersionSupervisor: item.grandGrandParentId,
                        idNSupervisor: this.$data.idNSupervisor
                    });

                console.log(JSON.stringify(data1.data));*/
            }
        }
        closeDialogChangeSupervisor() {
            this.$data.dialogChangeSupervisor = false;
            this.$data.idNSupervisor = this.$data.idNSupervisorAUX;
        }
        async bindTiposAndVariables() {
            this.$data.dialogChangeSupervisor = false;  
            this.$data.listItemSelected = [];
            this.$data.idNSupervisorAUX = this.$data.idNSupervisor;
            await this.loadTiposElementos();
            await this.loadVariables(); 
        }
        async openDialogChangeSupervisor() {            
            if (this.$data.listItemSelected.length > 0) {
                this.$data.dialogChangeSupervisor = true;                
            }
            else {
                await this.bindTiposAndVariables();              
            }
        }
        

        addVariable() {            
            if (this.$refs.formAddVariable != null) {
                if (!this.$refs.formAddVariable.validate()) {
                    return;
                }       
                const itemGrandFather = {
                    id: this.$data.itemVariable.idNTipoElemento
                };
                const nodeGrandFather = this.searchNodeGrandFather(this.$data.tiposElementosItems, itemGrandFather);                
                if (this.$data.listItemSelected.length === 0) {
                    
                    this.$data.tiposElementosItemsTemp = JSON.parse(JSON.stringify(this.$data.tiposElementosItems));
                    this.recursiveTiposElementosInicial(this.$data.tiposElementosItemsTemp, this.$data.itemVariable, nodeGrandFather.name, nodeGrandFather.path);
                }
                else {
                    var item = JSON.parse(JSON.stringify(this.$data.itemVariable));
                    if (this.$data.actionAddVariable === 'add') {
                        this.recursiveTiposElementosAdd(this.$data.tiposElementosItems, item, nodeGrandFather.name, nodeGrandFather.path);
                    }
                    else {                        
                        this.TiposElementosEdit(item);
                    }
                }
                this.$data.dialogAddVariable = false;
            }
        }      
       
       
        
        /**
         * Wizard
         * Editar un elemento de la Lista Derecha (Abuelo/ñietos)
         * @param item
         */
        TiposElementosEdit(item) {
            this.listItemSelected.forEach(grandFather => {
                grandFather.variables.forEach(p => {
                    if (p.id === item.id) {
                        p.name = item.nameNew;
                        return;
                    }
                });
            });
        }
        /**
         * Wizard
         * Remove un item de la lista de variables seleccionadas del lado derecho (Abuelos/ñietos)
         * @param item
         */
        removeItem(item) {           
            this.$data.listItemSelected.forEach(grandFather => {               
                const grandChildrensFiltered = grandFather.variables.filter(p => p.id != item.id);
                grandFather.variables = grandChildrensFiltered;
            });
            this.$data.listItemSelected = this.$data.listItemSelected.filter(grandFather => grandFather.variables.length > 0);

            this.enabledItemInMaster(this.$data.tiposElementosItems, item);
        }

        /**
         * Wizard
         * Habiliar el nodo ñieto en el lado izquierdo para poder volver a seleccionarlo si fuera necesario. Se ejecuta en secuencia con el metodo removeItem();
         * @param arrayObject
         * @param item
         */
        enabledItemInMaster(arrayObject, item) {
            const objElemen = arrayObject.find(elem => elem.level === 3 && elem.id === item.idNAgrupacionVariable && elem.parentId === item.idNTipoElemento);
            if (objElemen) {
                objElemen.children.forEach(p => {
                    if (p.id === item.id) {
                        p.selected = false;
                    }
                });

            }
            for (const node of arrayObject) {
                if (node.children) {
                    this.enabledItemInMaster(node.children, item);
                }
            }
        }
        /**
         * Wizard. Carga inicial del lado derecho. Cuando no hay elementos
         * @param arrayObject
         * @param item
         */
        recursiveTiposElementosInicial(arrayObject, item, nameGrandFather, pathName) {
           
            const objElemen = arrayObject.find(elem => elem.level === 3 && elem.id === item.idNAgrupacionVariable && elem.parentId === item.idNTipoElemento);
            if (objElemen) {                
                arrayObject.forEach(p => {
                    if (p.level === 3 && p.id === item.idNAgrupacionVariable && p.parentId === item.idNTipoElemento) {
                        p.children = objElemen.children.find(elem => elem.level === 4 && elem.id === item.id);                        
                        p.children.name = item.nameNew;
                        p.children.route = item.Path;
                        p.children.selected = true;
                        const grandChildren = [p.children];
                        const jsonPost = {
                            idNTipoElemento: item.idNTipoElemento, //id del abuelo
                            name: nameGrandFather,
                            path: pathName,
                            variables: grandChildren, //ñietos
                            active: false                            
                        }
                        this.$data.listItemSelected.push(jsonPost);
                    }
                })
            }                     
              
            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {                                        
                    this.recursiveTiposElementosInicial(node.children, item, nameGrandFather, pathName);
                }                
            }
        }
        /**
         * Wizard
         * Agregar un elemento cuando ya exista un elemento en la lista del lado izquierdo
         * @param arrayObject
         * @param item
         */
        recursiveTiposElementosAdd(arrayObject, item, nameGrandFather, pathName) {
            const objElemen = arrayObject.find(elem => elem.level === 3 && elem.id === item.idNAgrupacionVariable && elem.parentId === item.idNTipoElemento);
            if (objElemen) {                
                item.name = item.nameNew;
                item.route = item.Path;                
               
                //Si el Abuelo Existe en el lado derecho
                const countGrandFather = this.$data.listItemSelected.filter(grandFather => grandFather.idNTipoElemento === item.idNTipoElemento).length;
                if (countGrandFather > 0) {
                    this.$data.listItemSelected.forEach(grandFather => {
                        if (grandFather.idNTipoElemento === item.idNTipoElemento) {
                            grandFather.variables.push(item);
                            return;
                        }
                    })
                }
                else {
                    //Si el Abuelo NO EXISTE
                    const jsonPost = {
                        idNTipoElemento: item.idNTipoElemento, //id del abuelo
                        name: nameGrandFather,
                        path: pathName,
                        variables: [item], //ñietos
                        active: false                        
                    }
                    this.$data.listItemSelected.push(jsonPost);
                }
            }
            for (const node of arrayObject) {
                if (node.children) {
                    this.recursiveTiposElementosAdd(node.children, item, nameGrandFather, pathName);
                }
            }
        }  

        /**
         * Wizard
         * Agregar Variable desde el abuelo          
         */
        async openDialogAddVariableByLote(item) {
            if (!item.selected) {
                const nodeGrandFather = this.searchNodeGrandFather(this.$data.tiposElementosItems, item);

                if (nodeGrandFather) {
                    let grandChildren = [];
                    nodeGrandFather.children.forEach(async child => {                        
                        const data = await new ElementTypeService()
                            .listTiposVariables({
                                idNAgrupacionVariable: child.id,
                                idNTipoElemento: child.parentId,
                                idNAgrupacionElemento: child.grandParentId,
                                idNVersionSupervisor: child.grandGrandParentId,
                                idNSupervisor: this.$data.idNSupervisor
                            });
                        child.children = data.data;     
                        
                        child.children.forEach(granChild => {
                            if (!granChild.selected) {
                                granChild.selected = true;                               
                                grandChildren.push(granChild);
                            }
                        })
                        
                    });
                    const jsonPost = {
                        idNTipoElemento: nodeGrandFather.id, //id del abuelo
                        name: nodeGrandFather.name,
                        path: nodeGrandFather.path,
                        variables: grandChildren, //ñietos
                        active:false
                    }
                    this.$data.listItemSelected.push(jsonPost);
                }
            }
            else {
                //Preguntar si realmente quiere eliminar los items de la derecha       
                this.$data.itemSelected = item; //Guardo el valor del nodo ABUELO del lado izquierdo.
                this.$data.dialogConfirmCleanChildOfGrandFather = true;
            }
            
        }
        /**
         * Wizard
         * DeSeleccionar todos los ñietos perteneciente a un abuelo seleccionado
         * */
        cleanChildOfGrandFather() {

            const nodeGrandFather = this.searchNodeGrandFather(this.$data.tiposElementosItems, this.$data.itemSelected);
            const listItemOnlyGrandChild = this.$data.listItemSelected.find(p => p.idNTipoElemento === this.$data.itemSelected.id).variables;
            
            listItemOnlyGrandChild.forEach(nodeSelected => {               
               
                nodeGrandFather.children.forEach(child => {
                    
                    child.children.forEach(granChild => {
                        if (granChild.id === nodeSelected.id) {
                            granChild.selected = false;                            
                        }
                    })

                });
            });
            this.$data.listItemSelected = this.$data.listItemSelected.filter(p => p.idNTipoElemento !== this.$data.itemSelected.id);

            this.$data.dialogConfirmCleanChildOfGrandFather = false;
        }
        /**
         * Busqueda recursiva para el level 2 y el item.id
         * @param arrayObject
         * @param item
         */
        searchNodeGrandFather(arrayObject, item) {
            const objNode = arrayObject.find(elem => elem.level === 2 && elem.id === item.id);
            if (objNode) {
                return objNode;                
            }
            for (const node of arrayObject) {
                if (node.children) {
                    var rtn = this.searchNodeGrandFather(node.children, item);
                    if (rtn != null) {
                        return rtn;
                    }
                }
            }
        }
        /**
         * wizard
         * Open Dialgo y asignar por referencia la variable item
         * @param item
         */
        openEditGrandFatherName(item) {
            this.$data.itemGrandFather = item;
            this.$data.grandFatherNameNew = item.name;
            this.$data.dialogEditGrandFatherName = true;
        }
        /*
         * Wizard
         * Cambiar el nombre editado en la colección
         */
        changeGrandFatherName() {
            if (this.$refs.formChangeEditGrandFatherName != null) {
                if (!this.$refs.formChangeEditGrandFatherName.validate()) {
                    return;
                }
                this.$data.itemGrandFather.name = this.$data.grandFatherNameNew;
                this.$data.dialogEditGrandFatherName = false;
            }
        }

        openDialogAddVariable(item, action) {      
            this.$data.actionAddVariable = action;
            if (action === 'edit') {
                this.$data.dialogAddVariable = true;
                this.$data.itemVariable = item;
                this.$data.itemVariable.nameNew = item.name;                
            }
            else {
                if (!item.selected) {
                    this.$data.dialogAddVariable = true;
                    this.$data.itemVariable = item;
                    this.$data.itemVariable.nameNew = item.name;
                }
            }

        }      
        visitDescendants(obj, id) {
            for (const [key, value] of Object.entries(obj)) {
                if (value && typeof value === "object") {
                    // Recurse
                    this.visitDescendants(value, id);
                } else {                    
                    if (obj.level === 4 && obj.id === id) {
                        obj.sel = false;
                    }                    
                }
            }
        }

        closeDialogAddVariable(itemVariable) {
            itemVariable.nameNew = null;
            itemVariable.selected = false;
            this.$data.dialogAddVariable = false;
        }

        async loadData() {              
            var resultComp = await new CompanyService().list({});
            if (resultComp.success) {
                this.$data.companies = resultComp.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultComp.Message);
            }
            var res = await new InstalationCompanyRelationshipClassService().list(this.filter);
            if (res.success) {
                this.$data.tiposRelacionesInstalacionEmpresa = res.data;
            }
            else {
                this.showError('Ocurrio un error: ' + res.Message);
            }
            var resultMunic = await new MunicipalityService().list({});
            if (resultMunic.success) {
                this.$data.municipalities = resultMunic.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultMunic.Message);
            }

            var result = await new ContactService().list({});
            if (result.success) {
                this.$data.contacts = result.data;
            }
            else {
                this.showError('Ocurrio un error: ' + result.Message);
            }

            var resultIcons = await new IconService().list({});
            if (resultIcons.success) {
                this.$data.iconList = resultIcons.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultIcons.Message);
            }

            await this.loadVersions();
            if (this.$route.params.id) {
                var data = await new InstalationService().getInstalation(this.$route.params.id, null);
                
                if (data != null) {
                    if (data.success == false) {
                        this.showError(data.error);
                        return;
                    }
                    
                    const instalationData = data.descriptions;                    
                    this.editItem(instalationData);

                }
            }
            else {
                this.$data.nuevoForm = true;
                this.$data.instalation = new InstalationModel();
            }
            
            
        }
        async saveDataVariables() {

            const data = await new VariableService().insertElementVariable(this.$data.idNSupervisor, this.$data.listItemSelected);            
            if (data.success) {
                this.$data.listItemSelected = [];
                this.$data.idNSupervisor = null;
                this.$data.tiposElementosItems = [];
                this.$data.selectionVariables = [];
                this.$data.dialogConfirmSaveVariables = false;
                this.showSuccess('Los registros fueron guardados con exito');
            } else {
                this.$data.dialogConfirmSaveVariables = false;
                this.showError('Ocurrio un error al guardar las variables: ' + data.error);
            }            
        }
        addSupervisor() {            
            this.$data.supervisor = new SupervisorModel();
            this.$data.supervisor.fkNInstalacion = this.$data.instalation.idNInstalacion;
            this.$data.nuevoFormSupervisor = true;
        }
        editItemSupervisor(item) {
            this.$data.supervisor = JSON.parse(JSON.stringify(item));
            this.$data.nuevoFormSupervisor = true;
        }
        async saveDataSupervisor() {
            try {
                if (this.$refs.formularioNuevoSupervisor != null) {
                    if (!this.$refs.formularioNuevoSupervisor.validate()) {
                        return;
                    }
                }

                /*  if (this.$refs.formularioEdicion != null) {
                      if (!this.$refs.formularioEdicion.validate()) {
                          return;
                      }
                  }*/

                var uService = new SupervisorService();
                var data = null;
                if (this.$data.supervisor.idNSupervisor) {
                    data = await uService.update(this.$data.supervisor);
                } else {
                    data = await uService.insert(this.$data.supervisor);
                }

                if (data.success) {
                    this.nuevoFormSupervisor = false;
                    this.$data.supervisor.idNSupervisor = null
                    this.loadSupervisor();
                    this.showSuccess('El registro fue guardado correctamente');
                } else {
                    this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                }
            } catch (e) {
                console.log(e);
            }
        }
        async loadSupervisor() {
            let filterSupervisor = new SupervisorModel();
            filterSupervisor.fkNInstalacion = this.$data.instalation.idNInstalacion;
            //console.log(JSON.stringify(filterSupervisor));
            var resSup = await new SupervisorService().list(filterSupervisor);
            if (resSup.success) {
                this.$data.supervisors = resSup.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resSup.Message);
            }

        }
        async loadVersions() {
            var resultV = await new VersionService().list({});
            if (resultV.success) {
                this.$data.versions = resultV.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultV.Message);
            }
        }
        async loadTiposElementos() {
            var idNSupervisor = this.$data.idNSupervisor;
            if (idNSupervisor && !isNaN(idNSupervisor)) {
                //console.log(idNSupervisor);
                var resultTE = await new ElementTypeService().listBySupervisor(idNSupervisor);
                if (resultTE.success) {
                    //console.log(JSON.stringify(resultTE.data));
                    this.$data.tiposElementosItems = resultTE.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultTE.Message);
                }
            }
            else {
                this.$data.tiposElementosItems = [];
            }
        }
        async loadVariables() {
            var idNSupervisor = this.$data.idNSupervisor;
            if (idNSupervisor && !isNaN(idNSupervisor)) {
                //console.log(idNSupervisor);
                var resultVa = await new VariableService().listBySupervisor(idNSupervisor);
                if (resultVa.success) {
                    //console.log(JSON.stringify(resultVa.data));
                    this.$data.selectionVariables = resultVa.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultVa.Message);
                }
            }
            else {
                this.$data.selectionVariables = [];
            }
        }

       

        add() {
            this.$data.e1 = 1;
            this.$data.instalation = new InstalationModel();
            this.$data.supervisor = new SupervisorModel();
            this.$data.nuevoForm = true;
        }

       

        async saveMarker() {
            //console.log(this.$data.instalation.fldNLatitud + " - " + this.$data.instalation.fldNLongitud);
            if (!isNaN(this.$data.instalation.fldNLatitud) && !isNaN(this.$data.instalation.fldNLongitud)) {
                const newMarker = {
                    lat: this.$data.instalation.fldNLatitud,
                    lng: this.$data.instalation.fldNLongitud,
                };
                //console.log(JSON.stringify(newMarker));
                this.newMarkers = [];
                this.newMarkers.push({ position: newMarker });
                this.newCenter = newMarker;
                //console.log(JSON.stringify(this.newMarkers));
                //console.log(JSON.stringify(this.newCenter));
            }
        }

        async saveData() {
            try {
                if (this.$refs.formularioNuevo != null) {
                    if (!this.$refs.formularioNuevo.validate()) {
                        return;
                    }
                }

                if (this.$refs.formularioEdicion != null) {
                    if (!this.$refs.formularioEdicion.validate()) {
                        return;
                    }
                }

                var uService = new InstalationService(this.filter);
                var data = null;

                if (this.$data.instalation.idNInstalacion) {

                    // Este update tambien incluye la actualizacion de RelacionEmpresaInstalacion
                    data = await uService.update(this.$data.instalation);

                } else {

                    // Este insert tambien incluye la insercion de RelacionEmpresaInstalacion
                    /*let wizard = {
                        instalacion: this.$data.instalation,
                        supervisor: this.$data.supervisor
                    }
                    data = await uService.insert(wizard);*/
                    data = await uService.insert(this.$data.instalation);

                }

                const newMarker = {
                    lat: this.$data.instalation.fldNLatitud,
                    lng: this.$data.instalation.fldNLongitud,
                };
                this.newMarkers.push({ position: newMarker });
                this.newCenter = newMarker;

                if (data.success) {
                    if (this.nuevoForm) {                        
                        this.nuevoForm = false;
                        var dataInstalation = await new InstalationService().getInstalation(data.id, null);                        
                        if (dataInstalation != null) {
                            if (dataInstalation.success == false) {
                                this.showError(data.error);
                                return;
                            }
                            const instalationData = dataInstalation.descriptions;
                            this.editItem(instalationData);

                        }
                    }
                    
                    this.showSuccess('El registro fue guardado correctamente');
                } else {
                    this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                }
            } catch (e) {
                console.log(e);
            }
        }



        async actualizarRelacionEmpresaInstalacion() {
            var relacion = await new InstalationCompanyRelationshipService().getByInstalationAndCompany(this.instalation.idNInstalacion, this.instalation.fkNEmpresa);
            if (relacion.data[0] != null) {
                this.instalation.fkNTipoRelacionEmpresaInstalacion = relacion.data[0].fkNTipoRelacionEmpresaInstalacion;
                this.instalationAux.fkNTipoRelacionEmpresaInstalacion = relacion.data[0].fkNTipoRelacionEmpresaInstalacion;
            } else {
                this.instalation.fkNTipoRelacionEmpresaInstalacion = null;
                this.instalationAux.fkNTipoRelacionEmpresaInstalacion = null;
            }
        }
        getInstaDescription(id) {
            let desc = this.$data.instalations.find(function (e) {
                return e.idNInstalacion == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        }
        getVerDescription(id) {
            let desc = this.$data.versions.find(function (e) {
                return e.idNVersionSupervisor == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        }
        getUltimaTransmisionRecibida(date) {
            if (date != null) {
                return moment(date).format('DD/MM/YYYY HH:mm');
            } else {
                return "";
            }
        }

        getTypeDescription(id) {
            let desc = this.userTypes.find(function (e) {
                return e.idNTipoUsuario == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        }

        getContactName(id) {
            if (this.$data.contacts != null) {
                let name = this.$data.contacts.find(x => x.idNContacto == id);
                if (name)
                    return name.fldTNombre;
                return id;
            } else {
                return id;
            }
        }
        chkBotonCancelar() {
            // Estoy editando y presiono cancelar
            if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                this.$data.instalation = JSON.parse(JSON.stringify(this.$data.instalationAux));
                this.$data.puedeCambiar = false;
            } else {
                this.closeDialog();
            }
        }

        closeDialog() {


            this.puedeCambiar = false;
            this.alert = false;
            this.$data.instalation = new InstalationModel();
            this.$data.instalationAux = new InstalationModel();
        }

        async editItem(item) {

            //console.log(JSON.stringify(item));

            if (item.fldDApertura != null) {
                var apertura = new Date(item.fldDApertura);
                item.fldDApertura = apertura.toISOString().substr(0, 10);
            }

            if (item.fldDCierre != null) {
                var cierre = new Date(item.fldDCierre);
                item.fldDCierre = cierre.toISOString().substr(0, 10);
            }

            if (item.fldDAlta != null) {
                var alta = new Date(item.fldDAlta);
                item.fldDAlta = alta.toISOString().substr(0, 10);
            }

            if (item.fldDBaja != null) {
                var baja = new Date(item.fldDBaja);
                item.fldDBaja = baja.toISOString().substr(0, 10);
            }

            this.$data.modelEmpty = 0;            
            this.$data.instalation = JSON.parse(JSON.stringify(item));
            this.$data.instalationAux = JSON.parse(JSON.stringify(item));

            // Buscar su relacion, obtengo que tipo es y se la asign al modelo instalacion
            this.actualizarRelacionEmpresaInstalacion();
            this.$data.instalationAux = JSON.parse(JSON.stringify(item));

            //Bind Supervisores
            this.loadSupervisor();
            this.$data.editForm = true;

            //Bind Mapa
            const marker = {
                lat: this.$data.instalation.fldNLatitud,
                lng: this.$data.instalation.fldNLongitud,
            };
            this.markers.push({ position: marker });
            this.center = marker;
        }

       

     
        get activateEdit() {
            var sel = this.instalation;
            if (this.$auth.check('ADM'))
                return true;
            if (this.$auth.check('RE'))
                return true;
            if (this.$auth.check('RI') &&
                [sel.fkNGestor, sel.fkNTecnico, sel.fkNJefeZona, sel.fkNEjecutivo].indexOf(parseInt(this.$auth.user().id)) >= 0)
                return true;

            return false;
        }



        async mounted() {
            await this.loadData();
        }
        //Wizard
        active= [];        
        open = [];
        listItemSelected = [];
        idNSupervisorAUX = null;        
        dialogAddVariable = false;
        dialogChangeSupervisor = false;
        dialogConfirmSaveVariables = false;
        dialogConfirmCleanChildOfGrandFather = false;
        itemSelected = [];        
        // Para el detalle Instalacion
        detalleInstalation = false;
        itemVariable = {
            id: null,
            name: null,
            nameNew:null,
        };

        itemGrandFather = null;
        dialogEditGrandFatherName = false;
        grandFatherNameNew = "";

        nuevoForm = false;
        nuevoFormSupervisor = false;
        tab = "instalacion";
        tabsec = "variables";
        editForm = false;
        puedeCambiar = false;
        formularioNuevo = true;
        formularioEdicion = true;
        alert = false;
        markerData = {};

        // Listas
        instalations = [];
        municipalities = [];
        companies = [];
        contacts = [];
        provinces = [];
        tiposRelacionesInstalacionEmpresa = [];
        iconList = [];
        supervisors = []; //Supervisores
        versions = [];
        tiposElementos = [];
        idNSupervisor = null;

        //TreeView
        selectionType = 'leaf';
        tiposElementosItems = [];
        tiposElementosItemsTemp = [];
        selectionVariables = [];
        actionAddVariable = null;

        //Maps
        mapOptions = {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false,
            styles: [{
                'featureType': 'poi',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            }]
        };

        newZoom = 6;
        newCenter = { lat: 40.1530955, lng: -3.2961051 };
        newMarkers = [];

        zoom = 15;
        center = { lat: 0, lng: 0 };
        markers = [];

        // Modelos
        filter = new InstalationModel();
        instalation = new InstalationModel();
        instalationAux = new InstalationModel();
        relInstEmp = new InstalationCompanyRelationshipModel();
        supervisor = new SupervisorModel();
        e1 = 1;

        on = true;

        // Selects
        menuFechaApertura = false;
        menuFechaAperturaFilter = false;
        menuFechaAperturaEdit = false;
        menuFechaCierre = false;
        menuFechaCierreFilter = false;
        menuFechaCierreEdit = false;
        menuFechaAlta = false;
        menuFechaAltaEdit = false;
        menuFechaBaja = false;
        menuFechaBajaEdit = false;

        reglaNameNew = [
            v => !!v || 'Debe ingresar un nombre',
        ];
        grandFatherNameNewRule = [
            v => !!v || 'Debe ingresar un nombre',
        ];
        
        reglaCodigoInstalacion = [
            v => !!v || 'Debe ingresar un Código',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
        ];

        reglaMunicipio = [
            v => v && v > 0 || 'Debe seleccionar un Municipio'
        ];

        reglaEmpresa = [
            v => v && v > 0 || 'Debe seleccionar una Empresa'
        ];

        reglaNombreInstalacion = [
            v => !!v || 'Debe ingresar un Nombre',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
        ];

        reglaTipoRelacionInstalacionEmpresa = [
            v => v && v > 0 || 'Debe seleccionar un Tipo de Relación'
        ];


        //Reglas Supervisor
        versionRules = [
            v => v && v > 0 || 'Debe seleccionar una Version',
        ];
        nombreRules = [
            v => !!v || 'Debe ingresar un nombre',
        ];
        variableReceptoraRules = [
            v => !!v || 'Debe ingresar una Variable',
        ];
        ipRules = [
            v => !!v || 'Debe ingresar un IP',
        ];

        headers = [{
            text: '',
            value: 'ico1',
            sortable: false,
            width: 10
        }, {
            text: '',
            value: 'action',
            sorteable: false,
            width: 10
        }, {
            text: '',
            value: 'ico2',
            sortable: false,
            width: 10
        }, {
            text: '',
            value: 'fkNIcono',
            sortable: false,
            width: 10,
        }, {
            text: 'Cod.',
            value: 'fldTCodigo',
        }, {
            text: 'Nombre',
            value: 'fldTNombre'
        }, {
            text: 'GM',
            value: 'fkNGestor'
        }, {
            text: 'TM',
            value: 'fkNTecnico'
        }, {
            text: 'JZ',
            value: 'fkNJefeZona'
        }, {
            text: 'EJ',
            value: 'fkNEjecutivo'
        }, {
            text: 'Dirección',
            value: 'fldTDireccion'
        }, {
            text: 'Elementos',
            value: 'elementos'
        }, {
            text: 'Última transmisión',
            value: 'fldDUltimaTransmisionRecibida',
            width: 150
        }];

        //Supervisores
        headers_supervisores = [{
            text: '',
            value: 'ico1',
            sortable: false,
            width: 10
        },
        {
            text: '',
            value: 'action',
            sortable: false,
            width: 15
        },
        {
            text: 'Nombre',
            value: 'fldTNombre'
        },
        {
            text: 'Instalacion',
            value: 'fkNInstalacion'
        },
        {
            text: 'Version',
            value: 'fkNVersion'
        },
        {
            text: 'Variable Receptora NX',
            value: 'fldTVariableReceptoraNX'
        },
        {
            text: 'IP',
            value: 'fldTIp'
        },
        {
            text: 'Ultima Transmision Recibida',
            value: 'fldDUltimaTransmisionRecibida'
        },
        ];

    }
</script>

<style>
    .light-border {
        border: 1px solid #00000060 !important;
    }

    .element-tree-view {
        overflow-x: scroll !important;
        overflow-y: scroll !important;
        height: 480px;
        max-height: 480px;
        border: 1px solid #00000060 !important;
        padding: 4px;
    }

    .variable-tree-view {
        overflow-x: scroll !important;
        overflow-y: scroll !important;        
        height: 480px;
        max-height: 480px;
        margin-left: 12px !important;
        margin-right: 48px !important;
        border: 1px solid #00000060 !important;
        padding: 4px;
    }

    .item-font {
        font-size: 14px;
        font-weight: 400;
    }

    selected-variable-item {
    }

    .v-treeview--dense .v-treeview-node__root {
        min-height: 24px;
        padding: 0 !important;
    }

    .v-treeview-node__checkbox {
        margin-left: 0px !important;
    }

    .ml-24 {
        margin-left: 24px !important;
    }
    .checkMargin {
        margin-right: 30px
    }
    .v-treeview-node__prepend {
        margin-right:-25px !important;
    }

    .v-list-item {
        min-height: 32px !important;
    }
   /* .v-input--is-focused .v-input__slot {
        border: 1px solid #000000 !important;
        border-bottom-color: #000000 !important;
    }*/
    
   
</style>